import { render, staticRenderFns } from "./home-today-item.vue?vue&type=template&id=b0f0eed6&"
import script from "./home-today-item.vue?vue&type=script&lang=ts&"
export * from "./home-today-item.vue?vue&type=script&lang=ts&"
import style0 from "./home-today-item.vue?vue&type=style&index=0&id=b0f0eed6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports